/*
 * @Author: 小周
 * @Date: 2023-09-06 16:52:01
 * @LastEditTime: 2024-07-02 09:19:53
 * @LastEditors: MrZHLF
 * @Description: 路由页面
 */

import React from 'react'

import { createHashRouter } from 'react-router-dom'

import HomePage from '../views/home'
import AboutPage from '../views/about'
import DetailPage from '../views/detail'
import MoreComponents from '../views/moreComments'

const router = createHashRouter([
  {
    path: '/',
    element: <HomePage />,
    name: 'home',
  },
  {
    path: '/about',
    element: <AboutPage />,
    name: 'about',
  },
  {
    path: '/detail/:id',
    element: <DetailPage />,
    name: 'detail',
  },
  {
    path: '/more',
    element: <MoreComponents />,
    name: 'more',
  },
])

export default router
